<template>
    <section>
        <div class ="flex fixed fixed-max-sm middle space-between vertical-xs">
            <img loading="lazy" style="height: 32px" :src="glb.cdnUrl + 'vimages/ojo-network-new.svg'" alt="Top Local Real Estate Agents">
            <span class="text-center">Are you an agent or a broker?
            <br> Grow your business with the Movoto Select Network. </span>
            <a  href="https://agents.movoto.com/platforms/" rel="nofollow noreferrer" target="_blank" class="btn primary regular">Join Today</a>
        </div>
    </section>
</template>
<script src="./brokerage-banner.js"></script>
